import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {reactive, watch, ref} from 'vue'
import { AppNotification } from '@/interfaces/user.model';
import {useMainStore} from "@/store/main";


export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationsManager',
  setup(__props) {

const mainStore = useMainStore()
let show = ref<boolean>(false);
let text: string = '';
let color=ref<string>('info');
let showProgress=ref<boolean>(false);
let currentNotification: AppNotification | false = false;

async function  hide() {
  show.value = false;
  await new Promise((resolve, reject) => setTimeout(() =>function (){ resolve("") }, 500)).then(()=>{});
}
async function close() {
  console.log("close notifa")
  await hide();
  await removeCurrentNotification();
}

 async function removeCurrentNotification() {
  if (currentNotification) {
    await mainStore.removeNotification(mainStore.getContext, currentNotification);
  }
}
function firstNotification() {
  return mainStore.getFirstNotification;
}

 async function setNotification(notification: AppNotification | false) {

  if (show.value) {
    await hide();
  }
  if (notification) {

    currentNotification = notification;
    showProgress .value = notification.showProgress || false;
    show.value = true;
  } else {
    currentNotification = false;
  }
}

watch(firstNotification, async (newNotification: AppNotification | false, oldNotification: AppNotification | false) => {


  if (newNotification !== currentNotification) {

    await setNotification(newNotification);
    if (newNotification) {
      await mainStore.actionRemoveNotification(mainStore.getContext, {notification: newNotification, timeout: 6500});
    }
  }
})
function currentNotificationContent() {
  return currentNotification && currentNotification.content || 'default';
}

function currentNotificationColor() {
  return currentNotification && currentNotification.color || 'info';
}

/*export default  {

    const mainStore = useMainStore()
    _public show: boolean = false;
    _public text: string = '';
    _public showProgress: boolean = false;
    _public currentNotification: AppNotification | false = false;

    _public async hide() {
        this.show = false;
        await new Promise((resolve, reject) => setTimeout(() =>function (){ resolve() }, 500)).then(()=>{});
    }

    _public async close() {
        await this.hide();
        await this.removeCurrentNotification();
    }

    _public async removeCurrentNotification() {
        if (this.currentNotification) {
            commitRemoveNotification(this.$store, this.currentNotification);
        }
    }

    _public get firstNotification() {
        return readFirstNotification(this.$store);
    }

    _public async setNotification(notification: AppNotification | false) {
        if (this.show) {
            await this.hide();
        }
        if (notification) {
            this.currentNotification = notification;
            this.showProgress = notification.showProgress || false;
            this.show = true;
        } else {
            this.currentNotification = false;
        }
    }

    @Watch('firstNotification')
    _public async onNotificationChange(
        newNotification: AppNotification | false,
        oldNotification: AppNotification | false,
    ) {
        if (newNotification !== this.currentNotification) {
            await this.setNotification(newNotification);
            if (newNotification) {
                dispatchRemoveNotification(this.$store, { notification: newNotification, timeout: 6500 });
            }
        }
    }

    _public get currentNotificationContent() {
        return this.currentNotification && this.currentNotification.content || '';
    }

    _public get currentNotificationColor() {
        return this.currentNotification && this.currentNotification.color || 'info';
    }
}*/

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createBlock(_component_v_snackbar, {
    color: _unref(color),
    modelValue: _unref(show),
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(show) ? (show).value = $event : show = $event))
  }, {
    actions: _withCtx(() => [
      _createVNode(_component_v_btn, {
        variant: "text",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (close()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Close ")
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _withDirectives(_createVNode(_component_v_progress_circular, {
        class: "ma-2",
        indeterminate: ""
      }, null, 512), [
        [_vShow, _unref(showProgress)]
      ]),
      _createTextVNode(" " + _toDisplayString(currentNotificationContent()) + " ", 1)
    ]),
    _: 1
  }, 8, ["color", "modelValue"]))
}
}

})